export const TILE_SIZE = 32;
export const DEFAULT_MAP_WIDTH = 40;
export const DEFAULT_MAP_HEIGHT = 30;
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 4.0;
export const ZOOM_STEP = 0.1;
export const GRID_COLOR = 'rgba(255, 255, 255, 0.15)';
export const GRID_COLOR_STRONG = 'rgba(255, 255, 255, 0.3)';
export const SELECTION_COLOR = 'rgba(0, 120, 255, 0.4)';
export const CURSOR_COLOR = 'rgba(255, 255, 0, 0.5)';
export const UNDO_LIMIT = 100;

export const TOOLS = {
  PENCIL: 'pencil',
  RECT: 'rect',
  FILL: 'fill',
  ERASER: 'eraser',
  SELECT: 'select',
  PROPERTY: 'property',
  OBJECT: 'object',
  TERRAIN: 'terrain',
  SCATTER: 'scatter',
  LINE: 'line',
};

// Brush size limits
export const MIN_BRUSH_SIZE = 1;
export const MAX_BRUSH_SIZE = 10;

// Stamp memory slots
export const STAMP_SLOTS = 9;

export const PROPERTY_TYPES = {
  COLLISION: 'collision',
  OCCLUSION: 'occlusion',
  WATER: 'water',
};

// TMJ GID flag bits for flip/rotate
export const FLIPPED_HORIZONTALLY_FLAG = 0x80000000;
export const FLIPPED_VERTICALLY_FLAG = 0x40000000;
export const FLIPPED_DIAGONALLY_FLAG = 0x20000000;
export const GID_MASK = 0x1FFFFFFF;
